export const routes = (parentName) => {
  const ordersListName = `${parentName}-Orders`;
  const ordersViewName = `${parentName}-Orders-View`;

  return [
    {
      path: "orders",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          alias: "list",
          name: ordersListName,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },

        {
          path: "view/:id",
          alias: ":id",
          name: ordersViewName,
          component: () => import("./View.vue"),
        },
      ],
    },
  ];
};
